import React, { useEffect, useRef } from 'react';
import MapMarker from "../../Assets/Images/marker-icon.png"
const NeshanMap = ({ center }) => {
    const mapElement = useRef(null);
    const mapRef = useRef(null);
    // اضافه کردن یک رفرنس جدید برای نگهداری آبجکت مارکر
    const markerRef = useRef(null);

    useEffect(() => {
        const ol = window.ol;
        if (!mapElement.current) return;

        // ۱. ساخت شکل هندسی (Geometry) نقطه برای مارکر
        const markerGeometry = new ol.geom.Point(ol.proj.fromLonLat(center));

        // ۲. ساخت یک ویژگی (Feature) و قرار دادن نقطه در آن
        const markerFeature = new ol.Feature({
            geometry: markerGeometry
        });

        // ۳. استایل‌دهی به مارکر (استفاده از آیکون پیش‌فرض یا هر عکس دلخواه)
        markerFeature.setStyle(new ol.style.Style({
            image: new ol.style.Icon({
                anchor: [0.5, 1], // لنگر آیکون (تا نوک پایین آیکون دقیقاً روی نقطه قرار بگیرد)
                crossOrigin: 'anonymous',
                src: MapMarker, // آدرس تصویر مارکر
                scale: 0.3 // اندازه مارکر
            })
        }));

        // ذخیره مارکر در رفرنس برای تغییرات بعدی
        markerRef.current = markerFeature;

        // ۴. ساخت منبع داده (Source) و لایه (Layer) برای نمایش مارکر
        const vectorSource = new ol.source.Vector({
            features: [markerFeature] // قرار دادن فیچر مارکر داخل سورس
        });

        const vectorLayer = new ol.layer.Vector({
            source: vectorSource
        });

        // ۵. راه‌اندازی نقشه
        const map = new ol.Map({
            maptype: 'neshan',
            target: mapElement.current,
            key: 'web.253504bc8fe44800ac35f79c4d04625f',
            poi: true,
            traffic: true,
            view: new ol.View({
                center: ol.proj.fromLonLat(center),
                zoom: 14
            })
        });

        // ۶. اضافه کردن لایه مارکر به نقشه
        map.addLayer(vectorLayer);
        mapRef.current = map;

        return () => {
            map.setTarget(null);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Effect برای آپدیت موقعیت نقشه و مارکر
    useEffect(() => {
        if (mapRef.current && center) {
            const ol = window.ol;
            const newCenter = ol.proj.fromLonLat(center);

            // الف: حرکت دادن ویوی نقشه به مرکز جدید
            mapRef.current.getView().setCenter(newCenter);

            // ب: حرکت دادن مارکر به مرکز جدید
            if (markerRef.current) {
                // با استفاده از setCoordinates موقعیت نقطه عوض می‌شود
                markerRef.current.getGeometry().setCoordinates(newCenter);
            }
        }
    }, [center]);

    return (
        <div
            ref={mapElement}
            className='map-container'
            style={{ width: '100%', height: '400px', borderRadius: '8px', overflow: 'hidden' }}
        />
    );
};

export default NeshanMap;